var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "url(#pattern0_1013_71)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1013_71",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1013_71",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1013_71",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADz0lEQVR4nO3dS4iOURzH8b9rbpNbiA2ycNkgJRFRKEqyUHYuZTGsbCzsJFKMxmWBpTKDrMnGJeQyuYUxhKYZt5FLLguXeX11OAveufTOcznP+T/P+dTbNPXOOef5vU9n5jnn/zwjQC9gE9AElHCvZPuuNmORvAI2449qySvgMf5okrzKaLroSknyCs9IXuEZySs8I92PdThQC7TivxagBhiqKmj+htyIPvf/hI2eoGvRq0ZT0C/Qq0VT0CX0KmkKWjXvDkBC0CHoOMIZ7UgI2pEQtCMhaEdC0I6EoB0JQTsSgnYkBO1ICNqRELQjIWhHQtAOg27DH215XiY9gj8O5znoKnOAGZ/ZbXYMVbkNOg3AsS76u2PLBvpFaFO1tIIe0kXx5K0YbaqWbML/BzML+F7W3+0Y7amWbLodw9la1t+dGG2plmyyHcPpDZz7p7+rMdpSLdlkOw9otAkYeAusiNGOaqIFyokWKCdaoJxogXKiBcqJFsBH9PqYVAhjgQ3ASeAe8Br4Yb/eA04A6837YvRxGr1OxQ14KlDXgyLxduA4MCVCX9OAL+jzGZgcNeC+wO4YVfjtwC7TTg/7nW1vvtHirlnziRrySOBSQgO5CIyIMIYpwOIuXqsr7PtoN20k8Yp2FtsDHAhcIVk3gMGRB9VxjGMq6PMm0F98leIvpBMOg/4ATBBfmQUh0rXcQdC/gFXiK7vc+STloJtMPykHXSM+AxbixvwUg77h9bxsAIccBX0gofXvcu+B8eI7+1vahesJTXNmk+HfeTnyhoNTwEtHQb9IaLxLgad23BtEC3sl50K7FBkOSZGFMzp/c3SrFJn9G9SFa1JkwEFHQe+XIgMWOAp6nhSZvQhI+9Gaj5JY61DPXgSkaVnWx+gNu/mahrqsj80rdoflcsIhXwcGZX1s3jF7fMCFhEI+H2XPsDCAPsDOGFeM7cAO007Wx6ICMNHePvezwoBLppgk1g5xkdldjXVAva1leGUrlV7Z7+uAteZ9WY81CIIgCIIgCLJiC9C3ASsj/vwiYDswI/nRKQdMt5fdjWXFKeY5G6MqbGMYsKesgP0ZsBeYIwVf8F9hC8a78xXYZ8Lq7D+4ATPth2RKZrvTAKzp6Z0AatlbJzbaCs+eemfv/a63H9CbCG00A1uAAZJXwBLgIX547nU9cxRm8d2uxJl51zf1Zn4X7YBx5jE8+K0JmCRa2YdJPUCHZnNSiEYOi8yTclI08uxJjpX45v0tEp1RetvvQNEGOIsuDaL40tpc2WmZNhaIVmZxBzgDfMJPX20NyNyss4rqN894VoizIkgfAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleMessages);
export default __webpack_public_path__ + "static/media/multiple_messages.24b97ff4bd74b596ced06730e6ef776d.svg";
export { ForwardRef as ReactComponent };